import React from "react";
import { useContext, useState } from "react";
import { MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
	MultistepContext,
	MultistepContextValues,
} from "../../../types/context";
import { useIntl } from "react-intl";
import { styles } from "./FindTable";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import { useWindowResize } from "../../../hooks/useWindowResize";

export const MenuProps = {
	PaperProps: {
		className: "menuPaper",
		style: {
			maxHeight: 320,
		},
	},
};

//This component is a Select that changes the number of diners of the reservation
export const DinersSelect: React.FC<{ disabled: boolean }> = ({ disabled }) => {
	const { formatMessage } = useIntl();
	const { reservation, onChangeNumberDiners } = useContext(
		MultistepContext
	) as MultistepContextValues;

	const { isXSmall, isMobile } = useWindowResize();

	const [numberDiners, setNumberDiners] = useState(
		reservation.numberDiners !== 0 ? reservation.numberDiners : 1
	);

	//When the numberDiners changes, we set the reservation number diners
	const handleChange = (event: SelectChangeEvent) => {
		const selectedNumber = parseInt(event.target.value);
		setNumberDiners(selectedNumber);
		onChangeNumberDiners(selectedNumber);
	};

	return (
		<Select
			className="select"
			disabled={disabled}
			value={numberDiners.toString()}
			variant="outlined"
			IconComponent={ExpandMoreIcon}
			onChange={handleChange}
			sx={
				isXSmall || isMobile ? styles.cornerSelectMobile : styles.cornerSelect
			}
			MenuProps={MenuProps}
			renderValue={(selected) => {
				if (isMobile) {
					return (
						<Typography fontWeight={700}>
							<EmojiPeopleIcon
								fontSize="small"
								sx={{ mb: "-7px", pr: "5px" }}
							/>
							{"  "}
							{selected}
						</Typography>
					);
				} else {
					return (
						<Typography fontWeight={700}>
							{selected}{" "}
							{formatMessage({
								id: "findTable.diner",
								defaultMessage: "persona",
							})}
							{parseInt(selected) !== 1 ? "s" : ""}
						</Typography>
					);
				}
			}}
		>
			{Array.from({ length: reservation.service!.maxPeoplePerReservation }, (_, i) => i + 1).map((number) => (
				<MenuItem key={number} value={number} sx={{ fontWeight: 700 }}>
					{number}
				</MenuItem>
			))}
		</Select>
	);
};
